// extracted by mini-css-extract-plugin
module.exports = {"videoChat":"VideoChat_videoChat__2OYro","fixedAspectRatio":"VideoChat_fixedAspectRatio__3UgL8","isHidden":"VideoChat_isHidden__1y8Iq"};